import {Question, getFaqIndex} from "src/constants/faqIndex";
import {QA, SectionDivider, isSectionDivider} from "./types";
import {TranslateFn} from "@i18n";

export const getFaqs = (
  items: (Question | SectionDivider)[],
  t: TranslateFn,
): (QA | SectionDivider)[] => {
  const faqIndex = getFaqIndex(t);
  return items
    ? items.compact().map(item => (isSectionDivider(item) ? item : faqIndex[item]))
    : faqIndex.vals();
};
